/**
 * Settings module translations - Table section
 */

const table = {
  companyName: "Company Name",
  country: "Jurisdiction",
  peppolNumber: "Peppol Number",
  active: "Active",
  taxId: "Tax ID",
  languageForPDFs: "Language for PDFs",
  others: "Others",
  validFrom: "Valid from",
  validTill: "Valid till",
  useForInvoice: "Use for L'invoice",
  actions: "Actions",
  number: "#",
  sku: "SKU",
  description: "Description",
  classificationCode: "Classification code",
  act: "Act",
};

export default table;
